document.addEventListener('DOMContentLoaded', function () {
  var galleryFix = document.createElement('style');
  galleryFix.textContent = '.pdp-thumbnail{overflow:hidden}.pdp-thumbnail img{width:100%;height:100%;max-height:60px;min-height:0;object-fit:contain}.pdp-thumbnail.is-active{border-color:#168cff}';
  document.head.appendChild(galleryFix);
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var expand = menuToggle.getAttribute('aria-expanded') !== 'true';
      menuToggle.setAttribute('aria-expanded', String(expand));
      mobileMenu.hidden = !expand;
    });
  }
  var filterOpen = document.querySelector('[data-filter-open]');
  var filterClose = document.querySelector('[data-filter-close]');
  var filterSidebar = document.getElementById('filter-sidebar');
  if (filterOpen && filterSidebar) filterOpen.addEventListener('click', function () { filterSidebar.classList.add('is-open'); });
  if (filterClose && filterSidebar) filterClose.addEventListener('click', function () { filterSidebar.classList.remove('is-open'); });
  if (location.hash && location.hash.indexOf('#policy-') === 0) {
    var selectedPolicy = document.querySelector(location.hash);
    if (selectedPolicy && selectedPolicy.tagName === 'DETAILS') selectedPolicy.open = true;
  }
  document.querySelectorAll('.footer-policies a[href^="#policy-"]').forEach(function (link) {
    link.addEventListener('click', function () {
      var detail = document.querySelector(link.getAttribute('href'));
      if (detail) detail.open = true;
    });
  });
  var dialog = document.getElementById('OliShopDemoDialog');
  if (dialog) {
    document.querySelectorAll('[data-demo-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (!dialog.showModal) { window.alert('Preview only. Add this product under Shopify Admin → Products to create a real product detail page.'); return; }
        var title = trigger.dataset.demoTitle || 'Sample AirPods';
        var image = trigger.dataset.demoImage || '';
        var price = trigger.dataset.demoPrice || '';
        dialog.querySelector('[data-demo-dialog-title]').textContent = title;
        dialog.querySelector('[data-demo-dialog-price]').textContent = price + ' • example price';
        var pic = dialog.querySelector('[data-demo-dialog-image]');
        pic.src = image;
        pic.alt = title + ' example image';
        dialog.showModal();
      });
    });
    dialog.querySelectorAll('[data-demo-close]').forEach(function (button) {
      button.addEventListener('click', function () { dialog.close(); });
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  }
  var variantSelect = document.querySelector('[data-pdp-variant]');
  if (variantSelect) variantSelect.addEventListener('change', function () {
    var opt = variantSelect.options[variantSelect.selectedIndex];
    var price = document.querySelector('[data-pdp-price]');
    var availability = document.querySelector('[data-pdp-availability]');
    var add = document.querySelector('[data-pdp-add]');
    if (price) {
      price.textContent = opt.dataset.price || '';
      if (opt.dataset.compare) {
        var strike = document.createElement('s');
        strike.textContent = opt.dataset.compare;
        price.appendChild(strike);
      }
    }
    var inStock = opt.dataset.available === 'true';
    if (availability) availability.textContent = inStock ? '✓ In stock' : 'Currently out of stock';
    if (add) { add.disabled = !inStock; add.textContent = inStock ? 'Add to Cart' : 'Sold Out'; }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', opt.value);
    history.replaceState(null, '', url);
  });
  var pdpImage = document.querySelector('.pdp-large-image');
  var pdpThumbs = [].slice.call(document.querySelectorAll('[data-product-thumb]'));
  var pdpIndex = 0;
  function showPdpImage(i) {
    if (!pdpImage || !pdpThumbs.length) return;
    pdpIndex = (i + pdpThumbs.length) % pdpThumbs.length;
    var thumb = pdpThumbs[pdpIndex];
    // srcset overrides src in the browser, so clear it before swapping the photo
    pdpImage.removeAttribute('srcset');
    pdpImage.removeAttribute('sizes');
    pdpImage.src = thumb.dataset.src;
    pdpThumbs.forEach(function (b, j) {
      b.classList.toggle('is-active', j === pdpIndex);
      b.setAttribute('aria-current', j === pdpIndex ? 'true' : 'false');
    });
  }
  pdpThumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { showPdpImage(i); });
  });
  if (pdpImage && pdpThumbs.length > 1) {
    var swipeBox = pdpImage.parentElement || pdpImage;
    var startX = null, startY = null;
    swipeBox.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    swipeBox.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) showPdpImage(pdpIndex + (dx < 0 ? 1 : -1));
      startX = null;
    }, { passive: true });
  }
});
